/** Coach/staff title options shown on contact and school-coach forms. */
export const COACH_TITLES = ["Head Coach", "Recruiting Coordinator", "Assistant Coach"] as const;
